import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { BetaFeedbackPage } from './beta-feedback.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: '',
        component: BetaFeedbackPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [BetaFeedbackPage],
})
export class BetaFeedbackPageModule {}
